import type { ProductVendor, Vendor } from '@ztechapps/common.contract'
import find from 'lodash/find'

/**
 * We will find from the productVendors list the defined vendor.
 * Then we just need to return the url for the product
 */
export const useVendorProductUrl = (productVendors: ProductVendor[], vendor: Vendor): string => {
  const productVendor = find(productVendors, (pv) => pv?.vendor?._id === vendor._id)

  //if cannot be found just return empty
  if (!productVendor) return ''

  //return the URL, but if the url is not defined, return an empty string
  return productVendor?.url ?? ''
}
